import apiFetch from "@wordpress/api-fetch";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";

const google_reviews = () => {
	const container = document.querySelector(".google-reviews");
	if (container) {
		let rev;
		apiFetch({ path: "/cl/v1/google-reviews/" }).then((response) => {
			const reviews = response.result.reviews;
			const reviewsHtml = reviews.reduce((acc, el) => {
				return (
					acc +
					`
                        <div class="google-review f-carousel__slide""><div class="google-review-inner">
                            <div class="stars-wrapper">
                                ${renderStars(el.rating)}
                            </div>
                            <div class="review-content">${el.text}</div>
                            <span class="author">${el.author_name}</span>
                        </div></div>
                    `
				);
			}, "");
			container.innerHTML = reviewsHtml;
		});

		let observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length) {
					new Carousel(container, {
						Dots: true,
						adaptiveHeight: true,
						Navigation: false,
						transition: "fade",
						infinite: false,
						breakpoints: {
							"(min-width: 1025px)": {
								center: true,
								Dots: false,
								slidesPerPage: 3,
								Navigation: {
									classes: {
										container: "f-carousel__nav google-reviews-nav",
										button: "f-button google-review-button",
										isNext: "is-next",
										isPrev: "is-prev",
									},
								},
							},
						},
					});
					observer.disconnect(); // stop observing once initialized
				}
			});
		});

		observer.observe(container, { childList: true });
	}

	function renderStars(rating) {
		return `<div class="stars" style="--rating-width: ${rating * 20}%"></div>`;
	}
};

window.addEventListener("load", function () {
	google_reviews();
});
